module.exports = {
	config: {
		resourceRegisterKey: 'tags'
	},

	model: {
		dirtyAssignedTags: {},
		newlyAddedIndex: 0
	},

	events: {
		toggleElement: {
			type: 'click',
			action: function(event) {
				var self = event.data.component;
				var $target = $(event.target);
				var $realTarget, categoryID, categoryDataID;

				// identify categoryData element and toggle it if possible
				if(
					($realTarget = $target.closest('.categoryData, .category')).length > 0 &&
					(categoryID = $realTarget.data('categoryId')) &&
					(
						(categoryDataID = $realTarget.data('categoryDataId')) ||
						(categoryDataID === null && self.model.turnedOffTagCategoryManagementGranted)
					)
				){
					var $button = $target.closest('button');
					if(
						$button.hasClass('tag') &&
						(
							self.resourceData.selectParentsGranted ||
							$realTarget.hasClass('noChildren')
						)
					){
						// identify existing tagAssignments
						var dataIndex, existingTag, existingTagAttributes, tagFound = false;
						for(dataIndex in self.resourceData.assignedTags){
							existingTag = self.resourceData.assignedTags[dataIndex] || {};
							existingTagAttributes = existingTag.attributes || {};
							if (existingTagAttributes.categoryID === categoryID && existingTagAttributes.categoryDataID === categoryDataID) {
								tagFound = true;
								break;
							}
						}

						// identify dirty tagAssignments
						var dirtyTagID = `${categoryID}_${categoryDataID}`;
						var dirtyTagFound = Boolean(self.model.dirtyAssignedTags[dirtyTagID]);
						var categoryInCharge = categoryDataID === null;
						var preparedAssignedCategory = {}
						var turnedOff = false
						var turnedOn = false
						var turnedOffByInheritance = false
						if(categoryInCharge){
							if((preparedAssignedCategory = self.resourceData.preparedAssignedCategories[categoryID])){
								turnedOff = preparedAssignedCategory.turnedOff;
								turnedOn = preparedAssignedCategory.turnedOn;
								turnedOffByInheritance = preparedAssignedCategory.turnedOffByInheritance;
							} else {
								turnedOffByInheritance = (self.resourceData.inheritedCategories || {})[categoryID] === false;
							}
						}

						if(tagFound) {
							if(dirtyTagFound) {
								if(categoryInCharge && ((!turnedOffByInheritance && !turnedOn) || turnedOff)) 	$realTarget.removeClass('selected dirty');
								else 																			$realTarget.addClass('selected').removeClass('dirty');
								if(categoryInCharge) 	$realTarget.removeClass('inherited')

								delete self.model.dirtyAssignedTags[dirtyTagID];
							} else {
								if(categoryInCharge && ((!turnedOffByInheritance && !turnedOn) || turnedOff)) 	$realTarget.addClass('selected dirty');
								else 																			$realTarget.removeClass('selected').addClass('dirty');
								if(categoryInCharge) 	$realTarget.addClass('inherited')

								if(categoryInCharge && turnedOff && turnedOffByInheritance) {
									$realTarget.removeClass('inherited');
									self.model.dirtyAssignedTags[dirtyTagID] = {
										type: 'update',
										id: existingTagAttributes[existingTag.primaryKey],
										categoryID: categoryID,
										categoryDataID: categoryDataID,
										relationDataIndex: dataIndex,
										primaryKey: existingTag.primaryKey,
										enabled: true
									};
								} else if(categoryInCharge && turnedOn && !turnedOffByInheritance){
									$realTarget.removeClass('inherited');
									self.model.dirtyAssignedTags[dirtyTagID] = {
										type: 'update',
										id: existingTagAttributes[existingTag.primaryKey],
										categoryID: categoryID,
										categoryDataID: categoryDataID,
										relationDataIndex: dataIndex,
										primaryKey: existingTag.primaryKey,
										enabled: false
									};
								} else {
									self.model.dirtyAssignedTags[dirtyTagID] = {
										type: 'delete',
										id: existingTagAttributes[existingTag.primaryKey],
										categoryID: categoryID,
										categoryDataID: categoryDataID,
										relationDataIndex: dataIndex,
										primaryKey: existingTag.primaryKey
									};
								}
							}
						} else {
							if(dirtyTagFound) {
								if(categoryInCharge && (!turnedOffByInheritance || turnedOff)) 	$realTarget.addClass('selected').removeClass('dirty');
								else 															$realTarget.removeClass('selected dirty');
								if(categoryInCharge) 	$realTarget.addClass('inherited')
								delete self.model.dirtyAssignedTags[dirtyTagID];
							} else {
								if(categoryInCharge && (!turnedOffByInheritance || turnedOff))	$realTarget.removeClass('selected').addClass('dirty');
								else 															$realTarget.addClass('selected dirty');
								if(categoryInCharge) 	$realTarget.removeClass('inherited')

								self.model.dirtyAssignedTags[dirtyTagID] = {
									type: 'create',
									categoryID: categoryID,
									categoryDataID: categoryDataID,
									relationDataIndex: self.resourceData.assignedTags.length + (self.model.newlyAddedIndex++),
									enabled: categoryInCharge && turnedOffByInheritance ? true : null
								};
							}
						}

						self.filter(self.model.filterAttributes, false, false)
					} else if($button.hasClass('collapseController') || $realTarget.find('> button.collapseController').length > 0){
						if($realTarget.hasClass('collapsed')){
							$realTarget.removeClass('collapsed');
						} else {
							$realTarget.addClass('collapsed');
						}
					}
				}
			}
		}
	},

	methods: {
		sanitizeResources: function(storage){
			this.model.dirtyAssignedTags = this.resourceData.dirtyAssignedTags || {};
			this.model.turnedOffTagCategoryManagementGranted = storage.user.hasAccessTo('usage:turnedOffTagCategoryManagement', this.scope)

			// estimate next available addIndex
			var d;
			for(d in this.model.dirtyAssignedTags || []){
				this.model.newlyAddedIndex = Math.max(this.model.newlyAddedIndex || 0, ((this.model.dirtyAssignedTags[d] || {}).relationDataIndex || 0) + 1);
			}
		},

		filter: function(filterAttributes, removeCollapsedStateToShowAllFilteredElements = true, grantRefreshOnEmptyFiltersToSanitizeCollapsables = true){
			this.model.filterAttributes = filterAttributes = filterAttributes || {};

			var c, cd, categoryData, categoryDataAttributes, matching;

			var name = String(filterAttributes.name || '').trim()
			var selected = filterAttributes.selected

			var matchers = {}
			var parentsOfMatchers = {}
			var childrenOfMatchers = {}

			this.$.removeClass('filterActive');
			this.$.find('.categoryData')
				.removeClass('matcher')
				.removeClass('parentOfMatcher')
				.removeClass('childOfMatcher')
			;

			if(name || selected !== undefined){
				// prevent initial collapse on filter change
				if(removeCollapsedStateToShowAllFilteredElements){
					this.$.find('.categoryData').removeClass('collapsed');
				}

				var regexp = new RegExp(name, 'i');
				for(c in this.resourceData.options){
					for(cd in this.resourceData.options[c].children){
						categoryData = this.resourceData.options[c].children[cd] || {};
						categoryDataAttributes = categoryData.resources || {};

						matching = (
							(!name || String(categoryData.name || '').match(regexp) !== null)
							&&
							(
								selected === undefined
								||
								(
									!!selected
									&&
									this.isSelected(categoryDataAttributes.categoryDataID)
								)
								||
								(
									!selected
									&&
									!this.isSelected(categoryDataAttributes.categoryDataID)
								)
							)
						)

						if(matching){
							matchers[categoryDataAttributes.categoryDataID] = true;
							delete parentsOfMatchers[categoryDataAttributes.categoryDataID];
							delete childrenOfMatchers[categoryDataAttributes.categoryDataID];

							for(var level in categoryData.indexChain || []){
								var relative = (this.resourceData.options[c].children[categoryData.indexChain[level] || '-'] || {}).resources || {}
								if(relative.categoryDataID && relative.categoryDataID !== categoryDataAttributes.categoryDataID){
									parentsOfMatchers[relative.categoryDataID] = true;
								}
							}
							for(var childCategoryDataID in categoryData.children || []){
								childrenOfMatchers[childCategoryDataID] = true;
							}
						}
					}
				}

				matchers = Object.keys(matchers);
				parentsOfMatchers = Object.keys(parentsOfMatchers);
				childrenOfMatchers = Object.keys(childrenOfMatchers);

				if(matchers.length > 0){
					this.$.find(matchers.map(categoryDataID => `.categoryData[data-category-data-id="${categoryDataID}"]`).join(',')).addClass('matcher')
				}
				if(parentsOfMatchers.length > 0){
					this.$.find(parentsOfMatchers.map(categoryDataID => `.categoryData[data-category-data-id="${categoryDataID}"]`).join(',')).addClass('parentOfMatcher')
				}
				if(childrenOfMatchers.length > 0){
					this.$.find(childrenOfMatchers.map(categoryDataID => `.categoryData[data-category-data-id="${categoryDataID}"]`).join(',')).addClass('childOfMatcher')
				}

				this.$.addClass('filterActive');
			} else if(grantRefreshOnEmptyFiltersToSanitizeCollapsables) {
				// reset collapse-state via refresh
				this.refresh(false);
			}
		},

		isSelected: function(categoryDataID){
			if(!categoryDataID) return false;

			var aT, dAT, tag;
			var result = false;

			for(aT in this.resourceData.assignedTags || []){
				if(((this.resourceData.assignedTags[aT] || {}).attributes || {}).categoryDataID == categoryDataID){
					result = true;
					break;
				}
			}

			for(dAT in this.model.dirtyAssignedTags || []){
				if((tag = (this.model.dirtyAssignedTags[dAT] || {})).categoryDataID == categoryDataID){
					if(result){
						if(tag.type === 'delete'){
							result = false;
						}
					} else {
						result = !tag.type || tag.type !== 'delete'
					}
					break;
				}
			}

			return result;
		}
	},

	hooks: {
		async onDecision($element, options){
			const usedOptions = {
				decisionOptions: {
					decisionType: options.decisionType,
					dirtyAssignedTags: this.model.dirtyAssignedTags
				}
			};

			if(this.config.isEnhanced !== false){
				const $enhancementComponent = $element.find('section.enhanced > [id^="c_"]').first()
				if($enhancementComponent.length > 0){
					usedOptions.enhancementComponent = getComponent($enhancementComponent)
				}
			}

			let tagPickerButton, modal
			this.closest('base_form_fields_tag-picker-button', c => tagPickerButton = c)
			this.closest('base_modal_modal', c => modal = c)

			// hide modal if necessary
			if(modal){
				await modal.hide()
			}

			// tell tag-picker-button about the dirty resources
			if(tagPickerButton){
				await tagPickerButton.trigger('onDecision', usedOptions)
			} else {
				console.error('missing tagPickerButton to process decision')
			}
		}
	}
}